import {
  CollectorReleaseCache,
  convertCollectorReleaseCache,
  LatestCollectorReleaseCache,
  StoredCollectorReleaseCache,
} from "utils/collector";
import {
  UserPreferences,
  StoredUserPreferences,
  convertPreferences,
  LatestUserPreferences,
} from "utils/preferences";

export type LocalStorageSchema = {
  preferences: {
    current: UserPreferences;
    known: StoredUserPreferences;
  };
  collectorReleaseCache: {
    current: CollectorReleaseCache;
    known: StoredCollectorReleaseCache;
  };
};

export function getConverter<K extends keyof LocalStorageSchema>(
  section: K,
): (known: LocalStorageSchema[K]["known"]) => LocalStorageSchema[K]["current"] {
  switch (section) {
    case "preferences":
      return convertPreferences;
    case "collectorReleaseCache":
      return convertCollectorReleaseCache;
    default:
      throw new Error("unknown localStorage section");
  }
}

export function getLatestVersion(section: keyof LocalStorageSchema): number {
  switch (section) {
    case "preferences":
      return 4 satisfies LatestUserPreferences["version"];
    case "collectorReleaseCache":
      return 1 satisfies LatestCollectorReleaseCache["version"];
    default:
      throw new Error("unknown localStorage section");
  }
}
